import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=691c37df&scoped=true&"
import script from "./shopDetail.vue?vue&type=script&lang=js&"
export * from "./shopDetail.vue?vue&type=script&lang=js&"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=691c37df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c37df",
  null
  
)

export default component.exports